import { create } from "zustand";

export const useCalling = create((set, get) => ({
  isVideo: false,
  isCollapse: false,
  setIsVideo: (value) => set((state) => ({ ...state, isVideo: value })),
  setIsCollapse: (value) => set((state) => ({ ...state, isCollapse: value })),
}));
